<div tabindex="-1"
    (mouseenter)="setShouldBlur(false)"
    (mouseleave)="setShouldBlur(true)">
    <div>
        <div class="dropdown-section">
            <div class="dropdown-header"
                *ngIf="showMoreResultsUrl && category">
                {{ CATEGORY_LABELS[category] }}
                <a class="btn btn-transparent arrow-right"
                   href="javascript:void(0)"
                   (click)="navigateToMoreResultsUrl(category)">
                </a>
            </div>
            <div>
                <div class="dropdown-item"
                     *ngFor="let result of results"
                     [ngClass]="{'active': (results | indexOf:result) === selectedIndex}"
                     (click)="clickResult()"
                     (mouseenter)="setSelectedIndexOnMouseEnter(result)">

                    <dt class="dropdown-item-term" *ngIf="!result.is_raw && result.display_security_id" [textContent]="result.display_security_id"></dt>
                    <dd class="dropdown-item-text">
                        <div [innerHTML]="getResultNameText(result)" [attr.data-test-id]="getResultNameText(result)"></div>
                        <div class="dropdown-item-descr" *ngIf="result.desc" [textContent]="result.desc"></div>
                    </dd>
                </div>
            </div>
        </div>
        <ng-container *ngTemplateOutlet="footerTemplate; context: { $implicit: this }"></ng-container>
    </div>
</div>
